import { useMeterBarLayoutSize } from '../../shared/context/MeterBarLayoutSizeContext.js';
import { useMeterBarChartInternalConfig } from '../context/MeterBarChartInternalConfigContext.js';
import { buildThresholds } from '../utils/build-thresholds.js';

export const useMeterBarChartThresholds = (displayValue: number) => {
  const { min, max, thresholds, thresholdsIndicators } =
    useMeterBarChartInternalConfig();
  const { segmentWidth } = useMeterBarLayoutSize();

  return buildThresholds(
    displayValue,
    min,
    max,
    segmentWidth,
    thresholds ?? thresholdsIndicators,
  );
};
